/** Latest financial year allowed to download the tax statement (Edit this after tax statement is available each FY) */
export const TAX_STATEMENT_AVAILABLE_TO = 2024; // latest financial year allowed to download the tax statement

/** NOTE: Must be a descending order */
export const TAX_STATEMENT_AVAILABLE_DATES = [
  2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016,
];
